import { Printer } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { CashBreakdown } from "@/components/cash/CashBreakdown";
import { brl, fmtDateTime, PAY_LABELS } from "@/lib/api";

const Row = ({ l, v, cls = "" }) => <div className={`flex justify-between ${cls}`}><span>{l}</span><span>{v}</span></div>;

export function CashReport({ s, store, onClose }) {
  if (!s) return null;
  const sum = s.summary || {};
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md max-h-[90vh] overflow-y-auto" data-testid="cash-report-modal">
        <DialogHeader><DialogTitle>Relatório de caixa {s.number ? `#${s.number}` : ""}</DialogTitle></DialogHeader>
        <div className="print-area rounded-lg bg-white p-4 font-mono text-xs text-slate-900 space-y-1">
          <p className="text-center font-bold">{store}</p>
          <p className="text-center">{s.status === "closed" ? "RELATÓRIO DE FECHAMENTO DE CAIXA" : "RELATÓRIO PARCIAL DE CAIXA"}</p>
          <Row l="Caixa" v={s.kind === "ticket" ? "Venda ticket" : "PDV"} />
          {s.user_names?.length > 0 && <Row l="Usuários" v={s.user_names.join(", ")} />}
          <Row l="Abertura" v={`${fmtDateTime(s.opened_at)} · ${s.opened_by}`} />
          {s.closed_at && <Row l="Fechamento" v={`${fmtDateTime(s.closed_at)} · ${s.closed_by}`} />}
          <p className="border-t border-dashed border-slate-400 my-2" />
          <Row l={`Vendas (${sum.sales_count || 0})`} v={brl(sum.sales_total)} />
          {sum.cancelled_count > 0 && <Row l="Vendas canceladas" v={sum.cancelled_count} />}
          <p className="border-t border-dashed border-slate-400 my-2" />
          {sum.by_method && <CashBreakdown session={s} summary={sum} />}
          <p className="border-t border-dashed border-slate-400 my-2" />
          <p className="font-bold">Por forma de pagamento</p>
          {Object.entries(sum.by_method || {}).filter(([, v]) => v).map(([k, v]) => <Row key={k} l={PAY_LABELS[k]} v={brl(v)} />)}
          <p className="font-bold mt-2">Vendas por operador</p>
          {(sum.by_user || []).map((u) => <Row key={u.name} l={`${u.name} (${u.count})`} v={brl(u.total)} />)}
          {s.status === "closed" && (<>
            <p className="border-t border-dashed border-slate-400 my-2" />
            <p className="font-bold">Conferência</p>
            {Object.entries(s.differences || {}).map(([k, v]) => <Row key={k} l={`${PAY_LABELS[k]}: contado ${brl((s.counted || {})[k] ?? (k === "dinheiro" ? s.closing_amount : (sum.by_method || {})[k]))}`} v={brl(v)} cls={v < 0 ? "text-red-600" : ""} />)}
            <Row l="DIFERENÇA TOTAL" v={brl(s.total_difference ?? s.difference)} cls="font-bold text-sm" />
            {s.close_notes && <p>Obs.: {s.close_notes}</p>}
          </>)}
        </div>
        <DialogFooter><Button variant="outline" onClick={() => window.print()} data-testid="cash-report-print-btn"><Printer className="h-4 w-4 mr-2" />Imprimir</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
